import { render, staticRenderFns } from "./NewCSVReader.vue?vue&type=template&id=904596ea&scoped=true&"
import script from "./NewCSVReader.vue?vue&type=script&lang=js&"
export * from "./NewCSVReader.vue?vue&type=script&lang=js&"
import style0 from "./NewCSVReader.vue?vue&type=style&index=0&id=904596ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904596ea",
  null
  
)

export default component.exports